import { render } from "./VoteAddress.vue?vue&type=template&id=9b52e8f4&scoped=true"
import script from "./VoteAddress.vue?vue&type=script&lang=js"
export * from "./VoteAddress.vue?vue&type=script&lang=js"

import "./VoteAddress.vue?vue&type=style&index=0&id=9b52e8f4&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b52e8f4"]])

export default __exports__